import * as React from 'react';
import Post from './Post';
import { ArticleType } from '../../models/article.model';


interface IPostsProps {
    posts?: ArticleType[];
    handleBookmark: (post: ArticleType) => void;
    handleRemoveBookmark: (post: ArticleType) => void;
}

const Posts: React.FunctionComponent<IPostsProps> = ({ posts, handleBookmark, handleRemoveBookmark }) => {
    let showPost: React.JSX.Element | React.JSX.Element[] = <div className="alert alert-light border">No posts found for your search.</div>;
    if (posts && posts.length > 0) {
        showPost = posts.map(post =>
            <Post key={post.ID} post={post} handleBookmark={handleBookmark} handleRemoveBookmark={handleRemoveBookmark} />);
    }
    
    return (
        <div>{showPost}</div>
    );
};
export default Posts;
